// Copyright 2016 Sorama B.V.

import { Unit } from "units/Unit";

export class Size {
    constructor(width: number, height: number) {
        this.width = width;
        this.height = height;
    }

    public width: number;
    public height: number;
}

export class Rect {
    public x: number;
    public y: number;
    public width: number;
    public height: number;

    constructor(x: number, y: number, width: number, height: number) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }

    public copy(): Rect {
        return new Rect(this.x, this.y, this.width, this.height);
    }
}

export class Margin {
    constructor(left: number, top: number, right: number, bottom: number) {
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }

    public left: number;
    public top: number;
    public right: number;
    public bottom: number;
}

export class Pair<T> {
    constructor(x: T, y: T) {
        this.x = x;
        this.y = y;
    }

    public x: T;
    public y: T;
}

export enum DrawLayer {
    /** Drawn behind the plot, only visible in transparent areas */
    Background = -1,

    /** Drawn just above the plot and background but behind any other layers */
    AbovePlot = 1,

    /** Drawn over everything except for the top level layer */
    UserInterface = 2,

    /** Drawn at the very top of the plot */
    Overlay = 3,
}

export interface IPlotPart {
    readonly drawLayer: DrawLayer;

    onMeasureMargin(): Margin;

    onSize(size: Size, margin: Margin): void;

    onViewPortComputed(viewPort: Rect, viewPortBounds: Rect, units: Pair<Unit>): void;
}
